if (!customElements.get('product-specification-tabs')) {
  class ProductSpecificationTabs extends HTMLElement {
    connectedCallback() {
      this.tabButtons = Array.from(this.querySelectorAll('.pst-tab'));
      this.panels = Array.from(this.querySelectorAll('.pst-panel'));

      if (this.tabButtons.length === 0) return;

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const button = event.target.closest('.pst-tab');
      if (button && this.contains(button)) {
        event.preventDefault();
        this.activate(button);
      }
    }

    activate(button) {
      if (!button) return;
      const index = button.dataset.tabIndex;

      this.tabButtons.forEach((btn) => {
        const isActive = btn === button;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isTarget = panel.dataset.panelIndex === index;
        panel.toggleAttribute('hidden', !isTarget);
      });

      button.focus();
    }
  }

  customElements.define('product-specification-tabs', ProductSpecificationTabs);
}
